module.exports = __webpack_public_path__ + "static/media/files.97d5ae58.png";